import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Viewer from './pages/Viewer';

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Redirect root to a simple message */}
          <Route path="/" element={<Navigate to="/unauthorized" replace />} />
          
          {/* Direct PDF access routes only */}
          <Route path="/:path/:recordId" element={<Viewer />} />
          <Route path="/:recordId" element={<Viewer />} />
          
          {/* Simple unauthorized message */}
          <Route path="/unauthorized" element={
            <div style={{ 
              textAlign: 'center', 
              padding: '2rem',
              fontFamily: 'system-ui, sans-serif'
            }}>
              <h1>XRay.Tech PDF Viewer</h1>
              <p>Direct access only. No public navigation available.</p>
            </div>
          } />
        </Routes>
      </div>
    </Router>
  );
};

export default App; 